import { useState } from 'react';
import { Form, Input, InputNumber, Select, Button, message, Card, Switch, Tag } from 'antd';
import { ArrowLeftOutlined, SaveOutlined } from '@ant-design/icons';
import { createPlan } from './PlansapiFunction';
import { useNavigate } from "react-router-dom";

const { TextArea } = Input;
const { Option } = Select;

const CreatePlan = ({ onBack }) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (values) => {
    setLoading(true);
    try {
      const payload = {
        ...values,
        is_active: values.is_active ? '1' : '0'
      };
      const response = await createPlan(payload);
      if (response.data?.status === 'success') {
        message.success('Plan created successfully!');
        form.resetFields();
        setTimeout(onBack, 1000);
      }
    } catch (error) {
      message.error(error.response?.data?.message || 'Failed to create plan');
    }
    setLoading(false);
  };

  return (
    <div className="p-6">
      <button
        onClick={onBack}
        className="inline-flex mb-3 items-center gap-2 rounded-lg border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 shadow-sm transition-all hover:bg-gray-100 hover:shadow-md active:scale-95"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="h-5 w-5"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          strokeWidth={2}
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M15.75 19.5L8.25 12l7.5-7.5"
          />
        </svg>

        Back
      </button>
      <Card title="Create New Plan" className="shadow-sm">
        <Form
          form={form}
          layout="vertical"
          onFinish={handleSubmit}
          initialValues={{
            plan_type: 'paid',
            is_active: true,
            max_restaurants: 5,
            max_tables_per_restaurant: 50,
            features: []
          }}
        >
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {/* Left Column */}
            <div>
              <Form.Item
                name="name"
                label="Plan Name"
                rules={[{ required: true, message: 'Please enter plan name' }]}
              >
                <Input placeholder="e.g. Pro Plan" size="large" />
              </Form.Item>

              <Form.Item
                name="description"
                label="Description"
                rules={[{ required: true, message: 'Please enter description' }]}
              >
                <TextArea rows={3} placeholder="Plan description" />
              </Form.Item>

              <Form.Item
                name="plan_type"
                label="Plan Type"
                rules={[{ required: true }]}
              >
                <Select size="large">
                  <Option value="free">Free</Option>
                  <Option value="paid">Paid</Option>
                </Select>
              </Form.Item>

              <Form.Item
                name="price"
                label="Price (₹)"
                rules={[{ required: true, message: 'Please enter price' }]}
              >
                <InputNumber
                  className="w-full"
                  size="large"
                  min={0}
                  step={0.01}
                  prefix="₹"
                />
              </Form.Item>

              <Form.Item
                name="duration_days"
                label="Duration (Days)"
                rules={[{ required: true, message: 'Please enter duration' }]}
              >
                <InputNumber
                  className="w-full"
                  size="large"
                  min={1}
                />
              </Form.Item>
            </div>

            {/* Right Column */}
            <div>
              <Form.Item
                name="max_restaurants"
                label="Max Restaurants"
              >
                <InputNumber
                  className="w-full"
                  size="large"
                  min={0}
                  placeholder="Leave empty for unlimited"
                />
              </Form.Item>

              <Form.Item
                name="max_tables_per_restaurant"
                label="Max Tables Per Restaurant"
              >
                <InputNumber
                  className="w-full"
                  size="large"
                  min={0}
                  placeholder="Leave empty for unlimited"
                />
              </Form.Item>

              <Form.Item
                name="features"
                label="Features"
              >
                <Select
                  mode="tags"
                  size="large"
                  placeholder="Add features (press Enter)"
                  style={{ width: '100%' }}
                />
              </Form.Item>

              <Form.Item
                name="is_active"
                label="Active Status"
                valuePropName="checked"
              >
                <Switch
                  checkedChildren="Active"
                  unCheckedChildren="Inactive"
                />
              </Form.Item>

              <div className="flex gap-3 mt-4">
                <Button
                  type="primary"
                  htmlType="submit"
                  icon={<SaveOutlined />}
                  loading={loading}
                  size="large"
                  className="w-full"
                >
                  Create Plan
                </Button>
              </div>
            </div>
          </div>
        </Form>
      </Card>
    </div>
  );
};

export default CreatePlan;